<template>
  <div class="d-flex justify-content-center align-items-center w-100 h-100 font-large-2">
    You can!
  </div>
</template>

<script>
export default {
name: "index"
}
</script>

<style scoped>

</style>
